import CompaniesPage from '@/sections/companies/companies-page.vue';
import CompanySettings from '@/sections/companies/default-settings/company-settings.vue';
import PartsLocations from '@/sections/companies/parts-settings/parts-locations.vue';
import ServiceLocations from '@/sections/companies/service-settings/service-locations.vue';

export default [
	{
		name: 'companies',
		path: '/clients/:id/companies',
		component: CompaniesPage,
		props: route => ({
			customerName: route.params.customerName,
			companies: route.params.companies,
			search: route.params.search
		})
	},
	{
		name: 'company-settings',
		path: '/clients/:id/companies/edit/:companyCode',
		component: CompanySettings,
		props: route => ({
			customerName: route.params.customerName,
			company: route.params.company
		})
	},
	{
		name: 'parts-locations',
		path: '/clients/:id/companies/:companyCode/parts-locations',
		component: PartsLocations,
		props: route => ({
			id: route.params.id,
			companyCode: route.params.companyCode
		})
	},
	{
		name: 'service-locations',
		path: '/clients/:id/companies/:companyCode/service-locations',
		component: ServiceLocations,
		props: route => ({
			id: route.params.id,
			companyCode: route.params.companyCode
		})
	}
];
